export default "__VITE_ASSET__VuLNyHO9__"